<div class="bg-slate-100 min-h-screen flex items-center justify-center py-12 px-4">
  <div class="flex flex-col items-center w-full max-w-md px-6 py-8 bg-white rounded-lg shadow-lg">
    <a href="#" class="mt-4 flex items-center justify-center mb-6 text-2xl font-semibold text-black">
      <img class="w-auto max-w-[200px]" src="../../../assets/images/mav_logo.png" alt="logo">
    </a>
    <div class="flex w-full flex-col gap-6">
      <h1 class="text-xl font-thin leading-tight tracking-tight text-black md:text-2xl flex w-full justify-center items-center">
        Crear cuenta
      </h1>
      <form
        class="flex flex-col items-center justify-center w-full gap-4"
        (ngSubmit)="onSubmit()"
      >
        <div class="w-full flex flex-col gap-2">
          <label for="firstName" class="text-sm font-bold text-black">
            Nombre
          </label>
          <input
            type="text"
            name="firstName"
            id="firstName"
            class="border bg-transparent border-gray-300 text-black sm:text-lg rounded-lg block w-full p-2.5 focus:ring-2 focus:ring-slate-500 focus:border-slate-500 transition-all"
            placeholder="Ingrese su nombre"
            required
            [(ngModel)]="firstName"
          />
        </div>

        <div class="w-full flex flex-col gap-2">
          <label for="username" class="text-sm font-bold text-black">
            Nombre de Usuario
          </label>
          <input
            type="text"
            name="username"
            id="username"
            class="border bg-transparent border-gray-300 text-black sm:text-lg rounded-lg block w-full p-2.5 focus:ring-2 focus:ring-slate-500 focus:border-slate-500 transition-all"
            placeholder="usuario123"
            required
            [(ngModel)]="username"
          />
        </div>

        <div class="w-full flex flex-col gap-2">
          <label for="email" class="text-sm font-bold text-black">
            Correo Electrónico
          </label>
          <input
            type="email"
            name="email"
            id="email"
            class="border bg-transparent border-gray-300 text-black sm:text-lg rounded-lg block w-full p-2.5 focus:ring-2 focus:ring-slate-500 focus:border-slate-500 transition-all"
            placeholder="usuario@dominio.com"
            required
            [(ngModel)]="email"
          />
        </div>

        <div class="w-full flex flex-col gap-2">
          <label for="password" class="text-sm font-bold text-black">
            Contraseña
          </label>
          <input
            type="password"
            name="password"
            id="password"
            placeholder="*********"
            class="border bg-transparent border-gray-300 text-black sm:text-sm rounded-lg block w-full p-2.5 focus:ring-2 focus:ring-slate-500 focus:border-slate-500 transition-all"
            required
            [(ngModel)]="password"
          />
        </div>

        <div class="w-full flex flex-col gap-2">
          <label for="confirmPassword" class="text-sm font-bold text-black">
            Confirmar Contraseña
          </label>
          <input
            type="password"
            name="confirmPassword"
            id="confirmPassword"
            placeholder="*********"
            class="border bg-transparent border-gray-300 text-black sm:text-sm rounded-lg block w-full p-2.5 focus:ring-2 focus:ring-slate-500 focus:border-slate-500 transition-all"
            required
            [(ngModel)]="confirmPassword"
          />
        </div>

        <div class="flex flex-col items-center justify-center gap-4 w-full mt-2">
          <button
            type="submit"
            [disabled]="isLoading"
            class="w-full text-white bg-slate-500 hover:bg-slate-600 disabled:bg-slate-400 disabled:cursor-not-allowed focus:ring-4 focus:outline-none focus:ring-slate-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center flex items-center justify-center gap-2 transition-all duration-200"
          >
            <div *ngIf="isLoading" class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
            <span>{{ isLoading ? 'Registrando...' : 'Registrar' }}</span>
          </button>

          <!-- Mensaje de error -->
          <div *ngIf="errorMessage" class="text-red-500 text-sm bg-red-50 border border-red-200 rounded-lg p-3 flex items-center gap-2 w-full">
            <svg class="w-4 h-4 text-red-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
            </svg>
            <span>{{ errorMessage }}</span>
          </div>

          <!-- Mensaje de éxito -->
          <div *ngIf="successMessage" class="text-green-500 text-sm bg-green-50 border border-green-200 rounded-lg p-3 flex items-center gap-2 w-full">
            <svg class="w-4 h-4 text-green-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
            </svg>
            <span>{{ successMessage }}</span>
          </div>
        </div>

        <div class="flex flex-col items-center gap-2 mt-2">
          <p class="text-sm font-bold text-black">
            ¿Ya tienes cuenta?
          </p>
          <a
            href="/login"
            class="text-sm text-slate-600 hover:text-slate-800 hover:underline font-semibold transition-colors"
          >
            Iniciar sesión
          </a>
        </div>
      </form>
    </div>
  </div>
</div>
  